import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FINAL_CTA } from "@/data/content";
import { CtaButton, handleCta } from "./primitives";

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-brand-navy py-28 text-white md:py-40">
      <div className="noise-overlay pointer-events-none absolute inset-0 opacity-[0.05]" />
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-blue/25 blur-[150px]" />
        <div className="absolute bottom-0 left-10 h-64 w-64 rounded-full bg-brand-gold/12 blur-[110px]" />
      </div>

      <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-gold"
        >
          {FINAL_CTA.kicker}
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mx-auto mt-6 max-w-3xl font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
        >
          Você não precisa estudar tudo. Precisa estudar com{" "}
          <span className="gold-gradient-text animate-shimmer">estratégia.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/60 md:text-lg"
        >
          {FINAL_CTA.subtitle}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-10 flex justify-center"
        >
          <CtaButton size="lg" onClick={() => handleCta("checkout")} data-testid="final-cta">
            {FINAL_CTA.cta}
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </CtaButton>
        </motion.div>
        <p className="mt-6 text-sm font-medium text-white/40">{FINAL_CTA.microline}</p>
      </div>
    </section>
  );
}
